export default {
    get: (key, defaultValue) => {
        const value = (window.config || {})[key];

        if (value === undefined) {
            defaultValue = defaultValue || null;

            return defaultValue;
        }

        return value;
    },
};
